import { Login } from "../components/login/login";

export function LoginPage() {
  return <Login />;
}
